﻿angular.module("virtoCommerce.coreModule.seo", []);